module.exports = __webpack_public_path__ + "static/media/imgop_BBSRC-logo.e3439656.jp2";